export class AddPointCommandForTrench {
    _trench;
    _newPointPos;
    _pointID;
    _callback;
    constructor(trench, point, callback) {
        this._trench = trench;
        this._newPointPos = point;
        this._callback = callback;
    }
    async execute(viewer) {
        this._pointID = await this._trench.addIPPointAtEnd(this._newPointPos);
        await this._callback?.();
    }
    async undo(viewer) {
        await this._trench.removeControlPoint(this._pointID);
        await this._callback?.();
    }
}
export class RemovePointCommandForTrench {
    _trench;
    _pos;
    _removedPointID;
    _callback;
    _index;
    constructor(trench, pointID, callback) {
        this._trench = trench;
        this._removedPointID = pointID;
        this._callback = callback;
    }
    async execute(viewer) {
        this._pos = this._trench.getControlPointPos(this._removedPointID);
        this._index = this._trench.getControlPointIndex(this._removedPointID);
        await this._trench.removeControlPoint(this._removedPointID);
        await this._callback?.();
    }
    async undo(viewer) {
        await this._trench.restoreControlPointAtIndex(this._index, this._pos, this._removedPointID);
        await this._callback?.();
    }
}
export class UpdatePointPositionCommandForTrench {
    _trench;
    _newPointPos;
    _oldPos;
    _pointID;
    _callback;
    constructor(trench, newPos, pointID, callback) {
        this._trench = trench;
        this._newPointPos = newPos;
        this._pointID = pointID;
        this._callback = callback;
    }
    async execute(viewer) {
        this._oldPos = await this._trench.updateControlPointPosition(this._newPointPos, this._pointID);
        await this._callback?.();
    }
    async undo(viewer) {
        await this._trench.updateControlPointPosition(this._oldPos, this._pointID);
        await this._callback?.();
    }
}
export class UpdateHorizontalAlignmentTypeCommand {
    trench;
    _horizontalAlignmentType;
    _oldHorizontalAlignmentType;
    _callback;
    constructor(trench, horizontalAlignmentType, callback) {
        this.trench = trench;
        this._horizontalAlignmentType = horizontalAlignmentType;
        this._callback = callback;
    }
    async execute(viewer) {
        this._oldHorizontalAlignmentType =
            this.trench.alignment.horizontalAlignment.type;
        await this.trench.setTypeToHorizontalAlignment(this._horizontalAlignmentType);
        await this._callback?.();
    }
    async undo(viewer) {
        await this.trench.setTypeToHorizontalAlignment(this._oldHorizontalAlignmentType);
        await this._callback?.();
    }
}
export class AddControlPointOnTrenchCommand {
    _trench;
    _controlPointID;
    _callback;
    _pointID;
    constructor(trench, controlPointID, callback) {
        this._trench = trench;
        this._controlPointID = controlPointID;
        this._callback = callback;
    }
    async execute(viewer) {
        this._pointID = await this._trench.addIPPointOnTrench(this._controlPointID);
        await this._callback?.();
    }
    async undo(viewer) {
        await this._trench.removeControlPoint(this._pointID);
        await this._callback?.();
    }
}
export class AddControlPointAtIndexCommandOnTrench {
    _trench;
    _index;
    _callback;
    _point;
    _pointID;
    constructor(trench, index, point, callback) {
        this._trench = trench;
        this._index = index;
        this._point = point;
        this._callback = callback;
    }
    async execute(viewer) {
        this._pointID = await this._trench.addIPPointAtIndex(this._index, {
            localPosition: this._point,
        });
        await this._callback?.();
    }
    async undo(viewer) {
        await this._trench.removeControlPoint(this._pointID);
        await this._callback?.();
    }
}
//# sourceMappingURL=trench-commands.js.map